import React from 'react';

import "./Footer.css";

export const Footer = () => {
    return(
        <footer id="container-footer">
            <h4>© 2020 Copyright - Alexandre Raposo</h4>
        </footer>
    );
};